import { API_ROUTE_ADMIN_PHONE_SMS_LOGS_BY_BATCH } from '@/resources/api-routes'
import { get } from '@/util/auth'

import type { LogSmsPushOriginal } from './types'

const IS_NEW_BACKEND_API = true

export const getSMSLogReceiversList = async (batchId: string) =>
  (
    await get<{ smsLogs: LogSmsPushOriginal[] }>(
      API_ROUTE_ADMIN_PHONE_SMS_LOGS_BY_BATCH.replace(':batchId', String(batchId)),
      IS_NEW_BACKEND_API
    )
  ).smsLogs
